import "./App.scss";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Play from "./components/Play/Play";
import Header from "./components/Header/Header";
import Liquidity from "./components/Liquidity/Liquidity";
import Menubar from "./Menubar";
import { useEffect, useState } from "react";
import Themoon from "./components/Themoon/Themoon";
import Myprofile from "./components/Myprofile/Myprofile";
// import Welcome from "./components/Welcome/Welcome";
import { RecoilRoot, useSetRecoilState } from "recoil";
import { userProfileState } from "./components/recoilAtom";
import backendClient from "./utils/backendClient";
import Home from "./components/Home/Home";
import usePageReload from "./hooks/dataFetcher/Usepagereload";
import PageReloadManager from "./components/Pagereliadmanager";
import Footer from "./components/Footer/Footer";
import Games from "./components/Games/Games";
import Options from "./components/Options/Options";
// import Maintenance from "./components/Maintenance/Maintenance";

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const setUserProfile = useSetRecoilState(userProfileState);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const fetchUserProfile = async () => {
      const res = await backendClient.get("/users/user-profile");
      setUserProfile(res.data.data);
    };
    if (token) {
      fetchUserProfile();
    }
  }, [setUserProfile]);

  const handleSidebarToggle = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const shouldHideHeaderAndSidebar = location.pathname === "/welcome";
   const [theme, setTheme] = useState("light");

  const toggleTheme = () => {
    const newTheme = theme === "light" ? "dark" : "light";
    setTheme(newTheme);
    localStorage.setItem("theme", newTheme);
    document.documentElement.setAttribute("data-theme", newTheme);
  };

  usePageReload();
  return (
    <>
      <PageReloadManager maxIdleHours={24} />
      <ToastContainer style={{ fontSize: 20 }} />{" "}
      <>
        <Header onToggleSidebar={handleSidebarToggle} />
        <Menubar
          isOpen={isSidebarOpen}
          onClose={() => setIsSidebarOpen(false)}
        />
      </>
      <Switch>
        <Route exact path="/tothemoon" component={Themoon} />
        {/* <Route exact path="/maintenance" component={Maintenance} /> */}
        <Route exact path="/play" component={Play} />
        <Route exact path="/games" component={Games} />
        <Route exact path="/options">
          <Options theme={theme} toggleTheme={toggleTheme} />
        </Route>
        <Route exact path="/liquidity" component={Liquidity} />
        <Route exact path="/myprofile" component={Myprofile} />
        <Route exact path="/" component={Home} />
        <Route exact path="/:id" component={Home} />
        {/* <Route exact path="/welcome" component={Welcome} /> */}
      </Switch>
      {window.innerWidth < 992 && <Footer />}
    </>
  );
}

function AppWrapper() {
  return (
    <Router>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </Router>
  );
}

export default AppWrapper;
